<template>
  <button
    type="button"
    class="theme-toggle"
    :class="{'is-dark': isDark}"
    :aria-label="isDark ? 'Prepnúť na svetlú tému' : 'Prepnúť na tmavú tému'"
    :aria-pressed="isDark ? 'true' : 'false'"
    :title="isDark ? 'Svetlá téma' : 'Tmavá téma'"
    @click="toggleTheme"
  >
    <span class="theme-toggle__icon" aria-hidden="true">{{ isDark ? '☾' : '☀' }}</span>
    <span class="theme-toggle__track" aria-hidden="true">
      <span class="theme-toggle__thumb"></span>
    </span>
  </button>
</template>

<script>
import { applyTheme, DARK_THEME, LIGHT_THEME } from "@/utils/theme";

export default {
  name: "ThemeToggle",
  data: () => ({
    theme: DARK_THEME,
  }),
  computed: {
    isDark () {
      return this.theme === DARK_THEME;
    },
  },
  mounted () {
    this.theme = document.documentElement.dataset.theme || DARK_THEME;
    window.addEventListener("bankari-theme-change", this.handleThemeChange);
  },
  beforeDestroy () {
    window.removeEventListener("bankari-theme-change", this.handleThemeChange);
  },
  methods: {
    handleThemeChange (event) {
      this.theme = event.detail.theme;
    },
    toggleTheme () {
      this.theme = applyTheme(this.isDark ? LIGHT_THEME : DARK_THEME);
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-toggle {
  display: inline-flex;
  min-width: 62px;
  height: 36px;
  padding: 4px 6px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid var(--app-border);
  border-radius: 20px;
  outline: none;
  background: var(--app-surface);
  color: var(--app-primary);
  font: inherit;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.theme-toggle:hover,
.theme-toggle:focus-visible {
  border-color: var(--app-primary);
  box-shadow: 0 0 0 3px var(--app-primary-soft);
}

.theme-toggle__icon {
  width: 14px;
  font-size: 13px;
  line-height: 1;
}

.theme-toggle__track {
  position: relative;
  display: block;
  width: 28px;
  height: 16px;
  border-radius: 12px;
  background: var(--app-surface-strong);
  transition: background 0.2s ease;
}

.theme-toggle__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--app-primary);
  transition: transform 0.2s ease;
}

.theme-toggle.is-dark .theme-toggle__thumb {
  transform: translateX(12px);
}
</style>
